import React, { useState } from 'react';
import { SongIdeasSectionProps } from '../../types/planningTypes';
import EditSongIdeasModal from './EditSongIdeasModal';
import componentStyles from '../styles/components.module.css';

const SongIdeasSection: React.FC<SongIdeasSectionProps> = ({
  serviceId,
  songIdeas,
  liturgicalClass,
  onSongIdeasUpdate
}) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const hasIdeas = songIdeas && songIdeas.length > 0;
  const displayIdeas = isExpanded ? songIdeas : songIdeas.slice(0, 5);
  const showExpandToggle = songIdeas.length > 5;

  const handleEditClick = () => {
    setShowEditModal(true);
  };

  const handleModalClose = () => {
    setShowEditModal(false);
  };

  const handleUpdate = (updatedService: any) => {
    onSongIdeasUpdate(updatedService);
    setShowEditModal(false);
  };

  return (
    <>
      <div style={{ marginTop: '1.25rem' }}>
        <div className={componentStyles.sectionHeader}>
          <h4>Song ideas</h4>
          <i
            className={`bi bi-pencil-square ${componentStyles.editIcon}`}
            onClick={handleEditClick}
            title="Edit song ideas"
          />
        </div>

        <div className={componentStyles.container}>
          {hasIdeas ? (
            <>
              {displayIdeas.map((idea, index) => (
                <div
                  key={index}
                  className={`${componentStyles.item} ${componentStyles.idea}`}
                >
                  <div className={componentStyles.itemContent}>
                    <span>
                      {idea.title}
                      {(idea.composer || idea.lyricist || idea.tune) && (
                        <span className={componentStyles.versionTitle}>
                          {' · '}
                          {[
                            idea.composer && `${idea.composer}`,
                            idea.lyricist && `words ${idea.lyricist}`,
                            idea.tune && `tune ${idea.tune}`
                          ]
                            .filter(Boolean)
                            .join(' · ')}
                        </span>
                      )}
                    </span>
                  </div>
                </div>
              ))}

              {showExpandToggle && (
                <div
                  className="text-center mt-2"
                  style={{ cursor: 'pointer', color: '#666', fontSize: '0.875rem' }}
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? (
                    <>
                      Show less <i className="bi bi-chevron-up" style={{ fontSize: '0.75rem' }}></i>
                    </>
                  ) : (
                    <>
                      Show {songIdeas.length - 5} more <i className="bi bi-chevron-down" style={{ fontSize: '0.75rem' }}></i>
                    </>
                  )}
                </div>
              )}
            </>
          ) : (
            <div className={`${componentStyles.item} ${componentStyles.idea}`} style={{ color: 'var(--cl-text-muted)' }}>
              No ideas yet
            </div>
          )}
        </div>
      </div>

      <EditSongIdeasModal
        show={showEditModal}
        onHide={handleModalClose}
        serviceId={serviceId}
        songIdeas={songIdeas}
        onUpdate={handleUpdate}
      />
    </>
  );
};

export default SongIdeasSection;
